import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X, AlertCircle } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartNotification = () => {
  const { notification } = useCart();

  return (
    <AnimatePresence>
      {notification && (
        <motion.div
          initial={{ opacity: 0, y: -50, x: '-50%' }}
          animate={{ opacity: 1, y: 0, x: '-50%' }}
          exit={{ opacity: 0, y: -50, x: '-50%' }}
          className={`fixed top-24 left-1/2 z-[100] px-6 py-3 rounded-full shadow-lg flex items-center gap-2 ${
            notification.type === 'error'
              ? 'bg-red-500 text-white'
              : 'bg-brand-deepGreen text-white'
          }`}
        >
          {notification.type === 'error' ? (
            <AlertCircle className="w-5 h-5" />
          ) : (
            <Check className="w-5 h-5" />
          )}
          <span className="font-body text-sm font-medium">{notification.message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CartNotification;
